import { createAsyncThunk } from '@reduxjs/toolkit'
import { callErrorMsg } from 'helpers/errorMsg'
import { getPaymentDetail, postReversePayment } from 'features/Payment/services/paymentDashboard'
import { toastSuccess, toastFailed } from 'utils/toast'
import { SLICE_NAME, setIsLoading, setPaymentDetail } from './slice'

export const fetchPaymentDetail = createAsyncThunk(
  `${SLICE_NAME}/fetchPaymentDetail`,
  async ({ id }: { id: string }, { rejectWithValue, dispatch }) => {
    dispatch(setIsLoading(true))
    try {
      const {
        data: { data },
      } = await getPaymentDetail({ id })

      dispatch(setPaymentDetail(data))
      dispatch(setIsLoading(false))

      return data
    } catch (err) {
      callErrorMsg(err)
      dispatch(setIsLoading(false))

      return rejectWithValue(err)
    }
  },
)

export const updatePaymentRefund = createAsyncThunk(
  `${SLICE_NAME}/updatePaymentRefund`,
  async ({ id }: { id: string }, { rejectWithValue, dispatch }) => {
    dispatch(setIsLoading(true))
    try {
      const {
        data: { data },
      } = await postReversePayment({ id })

      if (data.success) {
        toastSuccess('Refund Berhasil')
      } else {
        toastFailed('Refund Gagal')
      }
      dispatch(setIsLoading(false))

      return data
    } catch (err) {
      callErrorMsg(err)
      dispatch(setIsLoading(false))

      return rejectWithValue(err)
    }
  },
)
